mutation DeleteStreamClip($contentId: ID!) {
  deleteStreamClip(contentId: $contentId)
}
